export const appConfig = {
  routes: {
    main: '/gb/dashboard',
    login: '/init',
  },
};
